import PhotoDocumentDelete from './PhotoDocumentDelete';

export default PhotoDocumentDelete;
